var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tab-bar" }, [
    _c(
      "div",
      { staticClass: "tab-bar__items" },
      _vm._l(_vm.tabBarItems, function (tabBarItem) {
        return _c("tab-bar-item", {
          key: tabBarItem.tab,
          attrs: {
            "is-active": _vm.isActiveTabBarItem(tabBarItem),
            "tab-bar-item": tabBarItem,
          },
          on: { click: _vm.onTabBarItemClick },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }